var map = {
	"./10_nuts.png": 2499,
	"./1drink_12beer.png": 2500,
	"./1serving_8ounces.png": 2501,
	"./1serving_8ounces2.png": 2502,
	"./1serving_8ounces3.png": 2503,
	"./1serving_8ounces4.png": 2504,
	"./1serving_8ounces5.png": 2505,
	"./8ounces_1glass.png": 2506,
	"./can_1.png": 2507,
	"./can_2.png": 2508,
	"./can_3.png": 2509,
	"./cup.png": 2510,
	"./dried_serving_1/4cup.png": 2511,
	"./dried_serving_1:4cup.png": 2512,
	"./fresh_serving_1cup.png": 2513,
	"./glass_1.png": 2514,
	"./glass_2.png": 2515,
	"./golfball.png": 2516,
	"./halfthumb.png": 2517,
	"./hand_1.png": 2518,
	"./hand_2.png": 2519,
	"./hand_3.png": 2520,
	"./hand_4.png": 2521,
	"./hand_5.png": 2522,
	"./how.png": 861,
	"./serving_1/2cup.png": 2523,
	"./serving_1:2cup.png": 2524,
	"./serving_1tbsp.png": 2525,
	"./serving_3/4ounces.png": 2526,
	"./serving_3:4ounces.png": 2527,
	"./thumbx2.png": 2528,
	"./usda.png": 2529,
	"./vegetables_1cup.png": 2530,
	"./what.png": 859,
	"./wholethumb.png": 2531,
	"./why.png": 860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;